import { TextField } from "@mui/material";
import React from "react";

export const FormInput = ({
  formName, handleChange, handleBlur, touched, errors, ...rest
}) => {
  return (
    <TextField
      id={formName}
      onChange={handleChange}
      onBlur={handleBlur}
      helperText={touched[formName] ? errors[formName] : ""}
      error={touched[formName] && Boolean(errors[formName])}
      variant="outlined"
      fullWidth
      {...rest}
    />
  );
};
